/**
 * Frontend build/recovery version.
 *
 * Bumped whenever a deploy needs every open tab/browser to pick up a clean
 * build and drop stale persisted app state (see utils/recoveryMigration.js).
 * Baked in at build time so it can be compared against `%REACT_APP_BUILD_VERSION%`
 * in public/index.html (see components/layout/VersionWatcher.js).
 */
export const BUILD_VERSION =
  process.env.REACT_APP_BUILD_VERSION || "2026-07-28-recovery-1";

export const getApiHost = () => {
  try {
    return new URL(process.env.REACT_APP_GRAPHQL_URL).host;
  } catch {
    return "unknown-host";
  }
};

let hasLoggedDiagnostics = false;

// Deliberately host/version only — never log tokens, cookies, or user data.
export const logBuildDiagnostics = () => {
  if (hasLoggedDiagnostics) return;
  hasLoggedDiagnostics = true;
  // eslint-disable-next-line no-console
  console.info(
    `[travelbay] build=${BUILD_VERSION} api=${getApiHost()} env=${process.env.NODE_ENV}`,
  );
};
